import { render, staticRenderFns } from "./PhotoBookOrderRow.vue?vue&type=template&id=857a59f8&scoped=true&"
import script from "./PhotoBookOrderRow.vue?vue&type=script&lang=js&"
export * from "./PhotoBookOrderRow.vue?vue&type=script&lang=js&"
import style0 from "./PhotoBookOrderRow.vue?vue&type=style&index=0&id=857a59f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857a59f8",
  null
  
)

export default component.exports